var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multiselect-popup"},[_c('div',{staticClass:"close",on:{"click":_vm.closeModal}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("mdi-close")])],1),_c('List'),_c('StatusChanger')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }